<template>
  <b-form-group
    id="fieldset-1"
    label="現在のステータス"
  >
    <b-form-select
      v-model="model"
      :options="items"
    >
    </b-form-select>
  </b-form-group>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'user/seatingStatus',
      attribute: 'now'
    }
  },

  computed: {
    items () {
      return this.$store.getters[`${this.modelName}/getAttr`]('nowOptions')
    },

    model: {
      get () {
        return this.$store.getters[`${this.modelName}/getAttr`](this.attribute)
      },

      set (value) {
        this.$store.commit(`${this.modelName}/setAttr`, {
          name: this.attribute,
          value
        })
      }
    }
  },

  created () {
    this.$store.dispatch(`${this.modelName}/getNowOptions`)
  }
}
</script>
